import { render, staticRenderFns } from "./PlanStructureTabs.vue?vue&type=template&id=603f6932&scoped=true"
import script from "./PlanStructureTabs.vue?vue&type=script&lang=js"
export * from "./PlanStructureTabs.vue?vue&type=script&lang=js"
import style0 from "./PlanStructureTabs.vue?vue&type=style&index=0&id=603f6932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603f6932",
  null
  
)

export default component.exports